import { useMutation } from '@tanstack/react-query';

import { FlightOperationNotification, FlightOperationNotificationClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightOperationNotificationClient = new FlightOperationNotificationClient(apiBaseUrl);

function useSaveNewFlightEvent() {
  return useMutation({
    mutationKey: [queryKeys.FlightOperationNotification.SaveNew],
    mutationFn: (report: FlightOperationNotification) => flightOperationNotificationClient.saveNew(report),
  });
}

export default useSaveNewFlightEvent;
